$(function(){
    var inputs = $('form input');
    var name;
    var phone_val,m_code_val,upwd_val,upwd2_val;
    var phone_p,m_code_p,upwd_p,upwd2_p;

    $(inputs).each(function(){
        name = $(this).attr('name');
        switch (name){
            case 'phone':
                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
                $(this).on('input',function(){
                    var els = [$('input[name=m_code]'),$('input[name=upwd]'),$('input[name=upwd2]')]
                    phone_p = getp(this)
                    phone_val = getval(this);

                    if(phone_val === ''){
                        errshow(phone_p,JL.phone_is_empty);
                    }else if(!myreg.test(phone_val)) {
                        errshow(phone_p,JL.phone_is_Wrongful);
                        setprop(els,true);
                    }else if(myreg.test(phone_val)){
                        $.ajax({
                            type:"get",
                            data:'phone='+phone_val,
                            url:jkas.url("/forgotpwd/check_mobile"),
                            dataType:'json',
                            success:function(result){
                                if(result.status == 1){
                                    setprop(els,false);
                                    phone_is_succ = true;
                                    succshow(phone_p,JL.phone_is_succ,'hide');
                                    console.log(121212)
                                }else if(result.status == 0){
                                    setprop(els,true);
                                    errshow(phone_p,JL.phone_is_registered);
                                }
                            }
                        });
                    }
                })
                break;
            case 'm_code':
				$(this).on('input',function(){
					m_code_p = getp(this,'parent')
					m_code_val = getval(this);
				})
				break;
            case 'upwd':
				var pwdreg = /^(\w){6,14}$/;
				$(this).on('input',function(){
					upwd_p = getp(this,'parent')
					upwd_val = getval(this);
					if(!pwdreg.test(upwd_val)){
						errshow(upwd_p,JL.reg_pwd)
					}else{
						succshow(upwd_p,JL.reg_pwd_succ)
					}
					if(upwd_val.length<=8){
						safety($('#safety-1'),'safety-1')
					}else if(upwd_val.length<=11){
						safety($('#safety-2'),'safety-2')
					}else if(upwd_val.length<=14){
						safety($('#safety-3'),'safety-3')
					}
				})
				break;
			case 'upwd2':
				$(this).on('input',function(){
					upwd2_p = getp(this);
					upwd2_val = getval(this);
					if(upwd_val != upwd2_val){
						errshow(upwd2_p,JL.reg_pwd_identical)
					}else if(upwd2_val == upwd_val){
						succshow(upwd2_p,JL.reg_pwd_succ)
					}
				})
				break;
            default :
                break;
        }
    })
    //发送验证码
    var phone_is_succ = false;
    var isFirst = true;
    var time = 60;
    $('#get_mcode').on('click',function(){
        var _phone = phone_val;
        var _this = this;
        if(phone_is_succ && isFirst || time <= 0){
            $.ajax({
                type:"post",
                data:_phone,
                async:false,
                url:jkas.url("forgotpwd/send_m_code","phone="+_phone),
                dataType:'json',
                success:function(result){
                    $('#get_mcode_p').show();
                    var timer = null;
                    isFirst = false;
                    time = 60;

                    timer = setInterval(function(){
                        time -- ;
                        $(_this).text(time+JL.send_m_code_again)
                        if(time <= 0){
                            $(_this).text(JL.send_m_code);
                            clearInterval(timer);
                        }
                    },1000)
                }
            })
        }
    })
    //提交
    $('#sub').on('click',function(){
        var data = $('form').serialize();
        if(phone_val!= undefined || m_code_val!= undefined || upwd_val!= undefined || upwd2_val!= undefined){        	
        	$.ajax({
        	    type:"post",
        	    data:data,
        	    url:jkas.url("forgotpwd"),
        	    dataType:'json',
        	    success:function(result){
        	        if(result.m_code == 0){
        	            errshow(m_code_p,JL.phone_Code_err,'hdie')
                        hide(m_code_p)
                        // layer.msg('')
        	        }
        	        if(result.status == 2){
        	            succ()
        	        }
        	    }
        	})
        }
    })
	//重置成功
	function succ(){
		$('.wrapper-box').hide();
		$('.succ-box').show();
	}

    // 公用方法
    function getp(t,parent){
		var _p = '';
		if(!parent){
			_p = $(t).parent().next('.warning')
		}else{
			_p = $(t).parent().parent().next('.warning')
		}
		return _p
	}
	function getval(t){
		return $(t).val()
	}
	function setprop(els,bool){
		for(var i=0;i<els.length;i++){
			$(els[i]).prop('disabled',bool);
		}
	}
	function succshow(p,txt,_hide){
		$(p).show(500).addClass('succ')
		.children('span').text(txt)
		.siblings('i').attr('class','fa fa-check')
		if(_hide){
			hide(p)
		}
	}
	function errshow(p,txt,_hide){
		$(p).show(500).removeClass('succ')
		.children('span').text(txt)
		.siblings('i').attr('class','fa fa-close');
		if(_hide){
			hide(p)
		}
	}
	function hide(p){
		var _p = p;
		setTimeout(function(){
			$(_p).hide(500)
		},1000)
	}
	function safety(el,safe){
		$('.safety dl').removeClass();
		el.addClass(safe+' active');
	}
})
